import { supabase } from '@/lib/supabase';

export const loadInvoicesService = async (shopId: string | number) => {
    try {
        const { data, error } = await supabase
            .from('Invoices')
            .select('*')
            .eq('shop_id', shopId)
            .order('created_at', { ascending: false });

        if (error) throw error;

        const parsedInvoices =
            data?.map((invoice: any) => ({
                id: invoice.id,
                number: `INV-${String(invoice.id).padStart(6, '0')}`,
                date: invoice.created_at,
                amount: invoice.amount_paid,
                status: invoice.status === 'paid' ? 'paid' : 'pending',
                currency: invoice.currency || 'eur',
                invoice_url: invoice.invoice_url,
            })) ?? [];

        return { success: true, data: parsedInvoices };
    } catch (error: any) {
        console.error('Errore nel caricamento delle fatture:', error);
        return { success: false, data: [] };
    }
};

export const loadSubscriptionService = async (shopId: string | number, organizationEmail?: string) => {
    try {
        const { data, error } = await supabase
            .from('Subscriptions')
            .select('*')
            .eq('shop_id', shopId)
            .maybeSingle();

        if (error) throw error;

        if (data) {
            const parsedSubscription = {
                plan_id: data.lookup_key ? data.lookup_key.split('_')[1] : '',
                status: data.status,
                amount: data.amount,
                billing_cycle: data.billing_cycle,
                current_period_end: data.current_period_end,
                cancel_at_period_end: data.cancel_at_period_end,
                customer_id: data.customer_id,
                subscription_id: data.subscription_id,
                payment_method: {
                    brand: data.brand,
                    last4: data.last4,
                    exp_month: data.exp_month,
                    exp_year: data.exp_year,
                },
                billing_details: {
                    name: data.customer_name,
                    email: organizationEmail || 'Email non disponibile',
                    address: data.billing_address,
                    vat_id: data.vat_number,
                },
            };

            return { success: true, data: parsedSubscription };
        } else {
            return { success: true, data: null };
        }
    } catch (error: any) {
        console.error('Errore nel caricamento della sottoscrizione:', error);
        return { success: false, data: null };
    }
};

export const createCustomerPortalSessionService = async (customerId?: string) => {
    try {
        const { data: { session }, error } = await supabase.auth.getSession();
        if (error || !session?.access_token) {
            throw new Error('Sessione scaduta. Accedi nuovamente per gestire i pagamenti.');
        }
        const res = await fetch(
            `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/customer-portal`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${session.access_token}`,
                    apikey: import.meta.env.VITE_SUPABASE_ANON_KEY,
                },
                body: JSON.stringify({
                    customer_id: customerId,
                }),
            },
        );

        if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
        }

        const data = await res.json();

        if (data.url) {
            return { success: true, url: data.url };
        } else {
            throw new Error('URL di checkout non ricevuto');
        }
    } catch (error: any) {
        return { success: false, error: error.message };
    }
};
